export enum AuthScreen {
  LOGIN = 'login',
  SSO = 'sso',
  PASSWORD = 'password',
}
